import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Tabs_nav from "../../app_structure/tabs_nav/tabs_home.jsx";
import Checking from "./checking";
import Send from "./send";
import Pay from "./pay";
import Cash_diary from './../../nhatkyorders.jsx';
import Option from "../../shop/ai/options.jsx";

const Coin_home = () => {
    const { slug_1, slug_2 } = useParams();
    return (
        <>
            <Tabs_nav category={'wallet_savings'} />
            {slug_1 === "home" && (
                <Option category={'savings_coins'} />

            )}
            {slug_1 === "plans" && (
                <Checking />
            )}
            {slug_1 === "orders" && (
                <Send />
            )}
            {slug_2 === "home" && (
                <Pay />
            )}
            {slug_2 === "cash_diary" && (
                <Cash_diary category_main={'savings_orders'} />
            )}
            {/* {slug_1 === "partner" && (
                <Coin_partner_home />
            )}
            {slug_1 === "exchange" && (
                <Coin_exchange />
            )}
            {slug_1 === "seller" && (
                <Coin_seller_home />
            )} */}
        </>
    );
}

export default Coin_home;
